/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Pricing_Annual_PaidInputs */

const en_pricing_annual_paid = /** @type {(inputs: Pricing_Annual_PaidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount} billed yearly`)
};

const es_pricing_annual_paid = /** @type {(inputs: Pricing_Annual_PaidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount} con facturación anual`)
};

/**
* | output |
* | --- |
* | "${amount} billed yearly" |
*
* @param {Pricing_Annual_PaidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_annual_paid = /** @type {((inputs: Pricing_Annual_PaidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Annual_PaidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_annual_paid(inputs)
	return en_pricing_annual_paid(inputs)
});